<template>
  <div class="flex flex-1">
    <div class="flex flex-col sm:flex-row flex-1 items-center justify-between border p-6">
      <div class="flex flex-col">
        <h1 class="text-lg text-center sm:text-left">Comanda #{{ order.id }}</h1>
        <span class="text-gray-700 text-sm">Plasată pe {{ order.formatted_created_at }}</span>
      </div>
      <h2 class="text-base text-gray-800 mt-1 sm:mt-0">{{status.text}}</h2>
      <div class="flex flex-row items-center mt-4 sm:mt-0">
        <inertia-link :href="route('shop.account.orders.view', { order: order.id })" class="btn-gray">Detalii</inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: Object
  },
  computed: {
    status() {
      return Object.values(this.$page.constants.order.statuses).filter( (status) => {
        return status.value == this.order.status
      })[0]
    },
  }
}
</script>
